// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"a3c4403a","2612":"a6506f96","3659":"a3baf1b7","3735":"8e16cb67","9289":"131da496"}[chunkId] + ".chunk.css";
};